'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { useEffect, useId, useState } from 'react';
export type AnalyticMetric = 'Budget' | 'Forecast' | 'ProtocolNetOutflow' | 'PaymentsOnChain' | 'Actuals';
const FILTERS: Array<{
  label: string;
  value: AnalyticMetric;
}> = [{
  label: 'Budget',
  value: 'Budget'
}, {
  label: 'Forecast',
  value: 'Forecast'
}, {
  label: 'Net Protocol Outflow',
  value: 'ProtocolNetOutflow'
}, {
  label: 'Net Expenses On-Chain',
  value: 'PaymentsOnChain'
}, {
  label: 'Actuals',
  value: 'Actuals'
}];
interface FilterTabsProps {
  selectedMetric: AnalyticMetric;
  onChangeTab: (metric: AnalyticMetric) => void;
}
function FilterTabs(t0) {
  const $ = _c(17);
  const {
    selectedMetric,
    onChangeTab
  } = t0;
  const id = useId();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [false, false];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [hasSmoke, setHasSmoke] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== id) {
    t2 = () => {
      const tab = document.getElementById(id);
      if (!tab) {
        return;
      }
      const handleScroll = () => {
        const hasLeft = tab.scrollLeft > 8;
        const hasRight = tab.scrollWidth - tab.scrollLeft - tab.clientWidth > 8;
        setHasSmoke([hasLeft, hasRight]);
      };
      tab.onscroll = handleScroll;
      handleScroll();
      return () => {
        tab.onscroll = null;
      };
    };
    t3 = [id];
    $[1] = id;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const t4 = hasSmoke[0] && "from-muted before:to-muted/0 before:pointer-events-none before:absolute before:top-0 before:left-0 before:h-full before:w-15 before:touch-none before:bg-linear-to-r before:content-['']";
  const t5 = hasSmoke[1] && "after:from-muted after:to-muted/0 after:pointer-events-none after:absolute after:top-0 after:right-0 after:h-full after:w-15 after:touch-none after:bg-linear-to-l after:content-['']";
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = cn("bg-background/25 relative max-w-full overflow-hidden rounded-t-xl shadow-xs", "md:min-w-48 md:rounded-l-xl md:rounded-tr-none", t4, t5);
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("no-scrollbar flex h-fit w-full min-w-48 overflow-x-scroll", "md:flex-col md:gap-2 md:py-4.5", "xl:min-w-51.25 xl:gap-2");
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== onChangeTab || $[9] !== selectedMetric) {
    t8 = FILTERS.map(tab_0 => {
      const isActive = tab_0.value === selectedMetric;
      return <Button key={tab_0.value} variant="ghost" data-slot="filter-tab" onClick={() => {
        onChangeTab(tab_0.value);
      }} className={cn("h-5.5 cursor-pointer justify-start pl-6 text-left text-xs whitespace-nowrap transition-colors md:text-sm", isActive ? "bg-accent text-foreground rounded-r-none py-2 leading-4.5 font-bold" : "text-muted-foreground py-1 leading-5.5 font-medium", "relative rounded-r-none md:py-0 md:leading-5.5", "md:before:absolute md:before:top-0 md:before:left-0 md:before:h-full md:before:w-1 md:before:rounded-r md:before:content-[\"\"]", isActive ? "md:bg-accent md:text-foreground md:before:bg-foreground" : "md:bg-transparent md:before:bg-transparent", !isActive && "md:hover:text-muted-foreground md:hover:bg-accent md:hover:before:bg-muted-foreground/50")}>{tab_0.label}</Button>;
    });
    $[8] = onChangeTab;
    $[9] = selectedMetric;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== id || $[12] !== t8) {
    t9 = <div id={id} data-slot="filter-tabs-container" className={t7}>{t8}</div>;
    $[11] = id;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t6 || $[15] !== t9) {
    t10 = <div data-slot="filter-tabs-wrapper" className={t6}>{t9}</div>;
    $[14] = t6;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}
export { FilterTabs };